import type { ActiveFiltersType } from "@cerebruminc/cerebellum";

export interface UserTableType {
	/** If present, will return a user with the matching email, or an empty table */
	tableState?: ActiveFiltersType;
}

export enum UserTableSortEnum {
	ID = "id",
	EMAIL = "email",
	FIRST_NAME = "firstname",
	LAST_NAME = "lastname",
	MIDDLE_NAME = "middlename",
	CREATED_AT = "createdAt",
	UPDATED_AT = "updatedAt",
	DELETED_AT = "deletedAt",
}

export enum UserTableFilterIds {
	Role = "roles",
	Organization = "organizations",
}
